import { render, staticRenderFns } from "./news-card.vue?vue&type=template&id=07a31d6c&scoped=true"
import script from "./news-card.vue?vue&type=script&lang=js"
export * from "./news-card.vue?vue&type=script&lang=js"
import style0 from "./news-card.vue?vue&type=style&index=0&id=07a31d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a31d6c",
  null
  
)

export default component.exports